module.exports = __webpack_public_path__ + "static/media/todo_app.a9653e89.PNG";